import {
    Briefcase,
    Scale,
    UserPlus,
    Building2,
    Stethoscope,
    FileText,
    FileCheck,
    BookOpen,
    CheckCircle2,
    HeartPulse,
    GraduationCap,
} from "lucide-react";

export const SOURCES = [
    { icon: Briefcase, label: "DFPS" },
    { icon: Scale, label: "JPO" },
    { icon: UserPlus, label: "Foster parents" },
    { icon: Scale, label: "Courts" },
    { icon: Building2, label: "Placement agencies" },
    { icon: Stethoscope, label: "Clinical referrers" },
];

export const STEPS = [
    {
        n: "01",
        icon: FileText,
        title: "Submit Referral Information",
        body: "Referral sources submit youth information for review. Our team will evaluate whether Crossroads to Change can safely and appropriately meet the youth's needs.",
    },
    {
        n: "02",
        icon: FileCheck,
        title: "Initial Review",
        body: "Our admissions team reviews available records — behavioral history, clinical needs, education status, medication information, and placement goals.",
    },
    {
        n: "03",
        icon: BookOpen,
        title: "Required Documents",
        body: "Please provide available clinical, medical, education, and placement / DFPS documents (full checklist below).",
    },
    {
        n: "04",
        icon: CheckCircle2,
        title: "Admissions Decision",
        body: "Once documents are reviewed, Crossroads to Change notifies the referral source regarding acceptance, denial, or need for additional information.",
    },
];

export const DOC_CATEGORIES = [
    {
        icon: HeartPulse,
        title: "Clinical / Behavioral Health",
        items: [
            "Current psychological or psychiatric evaluation",
            "Recent therapy notes (if available)",
            "Psychiatric medication monitoring notes",
            "Hospitalization records from the last 6 months (if applicable)",
            "CANS assessment (if applicable)",
        ],
    },
    {
        icon: Stethoscope,
        title: "Medical",
        items: [
            "Current medication list",
            "Medication administration records",
            "Allergies and medical conditions",
            "Recent physical or well-child documentation",
        ],
    },
    {
        icon: GraduationCap,
        title: "Education",
        items: [
            "Most recent report card",
            "ARD / IEP (if applicable)",
            "School withdrawal paperwork (if applicable)",
            "School behavior or incident reports",
        ],
    },
    {
        icon: FileText,
        title: "Placement / DFPS",
        items: [
            "Common Application",
            "Service Plan",
            "Legal status documentation",
            "Placement history",
            "Any safety plans or court orders",
        ],
    },
];

export const REFERRAL_SOURCE_OPTIONS = [
    "DFPS",
    "JPO",
    "Foster parent",
    "Court / juvenile justice",
    "CPA / placement agency",
    "Clinical referrer",
    "Other",
];

export const URGENCY = [
    { v: "low", label: "Planning ahead" },
    { v: "medium", label: "Within a few weeks" },
    { v: "high", label: "Within days" },
    { v: "urgent", label: "Immediate" },
];

export const INITIAL_FORM = {
    youth_name: "",
    youth_age: "",
    parent_guardian: "",
    referrer_name: "",
    referral_source: "DFPS",
    agency_name: "",
    phone: "",
    email: "",
    current_concerns: "",
    urgency_level: "medium",
    additional_notes: "",
};
